import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { DatePicker } from "react-advance-jalaali-datepicker";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import httpService from "../../../../services/httpServices/httpServices";
import typeAmountDiscount from "../campaign-banner/type-amount";
import messagesDiscountBanner from "../../../../messages/discount/banner";

export default function AddDiscountToPositionBanner() {
  const [amount, setAmount] = useState(0);
  const [positionPrice, setPositionPrice] = useState(0);
  const [position, setPosition] = useState();
  const [previewPrice, setPreviewPrice] = useState(0);
  const history = useHistory();
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  const params = useParams();
  const tagHtmlIDPosition = params.id;

  useEffect(() => {
    getPosotitonData(tagHtmlIDPosition);
  }, []);

  useEffect(() => {
    if (!position) {
      return;
    }

    setPositionPrice(position.pos_price);
  }, [position]);

  useEffect(() => {
    if (!positionPrice) {
      return;
    }
    changePreviewPrice();
  }, [amount]);

  const changePreviewPrice = () => {
    flushMessage();
    let previewPrice = positionPrice * ((100 - amount) / 100);
    if (previewPrice < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messagesDiscountBanner.AMOUNT_DISCOUNT_POSITION_BANNER_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    setPreviewPrice(previewPrice);
  };

  const flushMessage = () => {
    setMessage({});
  };

  const getPosotitonData = async (tagHtmlIDPosition) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const positionData = await sendRequestGetPosotitonTagHtmlIDData(
      tagHtmlIDPosition
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!positionData) {
      return false;
    }
    setPosition(positionData);
  };

  const sendRequestGetPosotitonTagHtmlIDData = async (positionTagHtmlID) => {
    let headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/report/" +
          positionTagHtmlID,
        headersRequest
      );
      return resultRequest.data.data;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const goScrollIntoTag = (tagID) => {
    const element = document.getElementById(tagID);
    element.scrollIntoView();
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddDiscountPositionBanner =
      await sendRequestAddDiscountPositionBanner(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddDiscountPositionBanner) {
      goScrollIntoTag('container-add-discount-banner-position')
      return;
    }
    history.push(`/manage/discount/select-position-banner`);
    return;
  };

  const sendRequestAddDiscountPositionBanner = async (dataForm) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/position-banner",
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
  };

  const getDataForm = () => {
    const startDate = document.querySelector("#start-date input").value;
    const endDate = document.querySelector("#end-date input").value;
    const startDateTime =
      document.querySelector("#hour-start-date-discount").value +
      ":" +
      document.querySelector("#minute-start-date-discount").value;
    const endDateTime =
      document.querySelector("#hour-end-date-discount").value +
      ":" +
      document.querySelector("#minute-end-date-discount").value;

    return {
      position_tag_html_ID: tagHtmlIDPosition,
      amount: amount + "",
      start_date_discount: startDate + "_" + startDateTime,
      end_date_discount: endDate + "_" + endDateTime,
      description: document.querySelector("#description").value,
    };
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اضافه کردن تخفیف به جایگاه بنری
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body" id="container-add-discount-banner-position">
              <div className="d-flex flex-row-reverse justify-content-between">
                <div className="text-left">
                  <Link
                    to="/manage/discount/select-position-banner"
                    className="btn btn-primary"
                  >
                    <span>بازگشت</span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left"></i>
                    </span>
                  </Link>
                </div>
                <div>
                  {messageTag}
                  <form onSubmit={sendForm}>
                    <div className="d-flex align-items-center">
                      <span>
                        مبلغ جایگاه
                        <span className="btn btn-secondary">
                          {tagHtmlIDPosition}
                        </span>
                      </span>
                      <span className="px-2">:</span>
                      <span className="pl-2 number-finance">
                        {positionPrice &&
                          helpersNumbers.toPersianNum(
                            helpersNumbers.addCommaToSeparateGroupThreeNumber(
                              positionPrice
                            )
                          )}{" "}
                      </span>
                      <span>تومان</span>
                    </div>
                    <div className="d-flex align-items-center py-2">
                      <span>مبلغ تخفیف خورده جایگاه</span>
                      <span className="px-2">:</span>
                      <span className="pl-2 number-finance">
                        {positionPrice &&
                          helpersNumbers.toPersianNum(
                            helpersNumbers.addCommaToSeparateGroupThreeNumber(
                              previewPrice
                            )
                          )}{" "}
                      </span>
                      <span>تومان</span>
                    </div>
                    <div className="form-group py-2">
                      <div className="d-flex align-items-center">
                        <span className="pl-2">
                          <label className="m-0">مقدار تخفیف</label>
                        </span>
                      </div>
                      <div>
                        <div className="input-group">
                          <input
                            type="number"
                            min="1"
                            max="99"
                            id="amount"
                            className="form-control number-finance"
                            dir="ltr"
                            onChange={(e) => {
                              setAmount(parseInt(e.target.value));
                            }}
                            required
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">٪</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <div className="py-2">
                          <label>تاریخ شروع (ساعت را ۲۴ ساعته وارد کنید)</label>
                        </div>
                        <div className="d-flex align-items-center">
                          <div id="start-date" className="custom-data-picker">
                            <div className="d-flex align-items-center">
                              <div>
                                <DatePicker
                                  placeholder="انتخاب تاریخ"
                                  format="jYYYY/jMM/jDD"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="text-nowrap pr-2">ساعت :</div>
                          <div className="px-2">
                            <input
                              className="form-control"
                              type="number"
                              id="hour-start-date-discount"
                              min="0"
                              max="23"
                              required
                            />
                          </div>
                          <div className="text-nowrap">دقیقه :</div>
                          <div className="pr-2">
                            <input
                              className="form-control"
                              type="number"
                              id="minute-start-date-discount"
                              min="0"
                              max="59"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="py-3">
                          <label>
                            تاریخ پایان (ساعت را ۲۴ ساعته وارد کنید)
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <div id="end-date" className="custom-data-picker">
                            <div className="d-flex align-items-center">
                              <div>
                                <DatePicker
                                  placeholder="انتخاب تاریخ"
                                  format="jYYYY/jMM/jDD"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="text-nowrap pr-2">ساعت :</div>
                          <div className="px-2">
                            <input
                              className="form-control"
                              type="number"
                              id="hour-end-date-discount"
                              min="0"
                              max="23"
                              required
                            />
                          </div>
                          <div className="text-nowrap">دقیقه :</div>
                          <div className="pr-2">
                            <input
                              className="form-control"
                              type="number"
                              id="minute-end-date-discount"
                              min="0"
                              max="59"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="pt-3">
                      <div>
                        <label className="py-2 m-0">توضیحات</label>
                      </div>
                      <div>
                        <textarea
                          id="description"
                          className="form-control"
                          rows="5"
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div className="pt-3">
                      <button className="btn btn-success">درج</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
